/* ============
 * Contract Module
 * ============
 */

import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

export default {
  state: {
    alternativeContracts: [],
    currentAlternativeContract: {},
    addedAlternativeLessorsIds: [],
    isAltContractRawEditing: false,
    alternativeKinds: {
      isExceptionToArticle3OfIFRS16: false,
      isIrrelevant: false,
      isShortTerm: false,
      isVariableLeasePayments: false,
      isNotRentContract: false,
      isLowValue: false,
    }
  },
  actions,
  getters,
  mutations
};
